const FORM_AUDIENCE_TYPE = {
    none: 0,
    students: 1,
    parentsForChildCompletion: 2,
    employees: 4,
    previousSchool: 5,
    externalUsers: 6,
};

export default FORM_AUDIENCE_TYPE;